export default __webpack_public_path__ + "static/media/012-soccer.c8d756bc.svg";